import { useLang } from "../i18n/LanguageContext";

// 19 real client logos — sorted alphabetically for a neutral order.
const LOGOS = [
  { src: "/clients/adm.jpeg", name: "ADM" },
  { src: "/clients/carmeuse.png", name: "Carmeuse" },
  { src: "/clients/cemrom.png", name: "Cemrom" },
  { src: "/clients/chimpex.png", name: "Chimpex" },
  { src: "/clients/comvex.jpg", name: "Comvex" },
  { src: "/clients/ecosud.webp", name: "Eco Sud" },
  { src: "/clients/ferrobeton.png", name: "Ferrobeton" },
  { src: "/clients/holcim.png", name: "Holcim" },
  { src: "/clients/iridex.png", name: "Iridex" },
  { src: "/clients/maria-trading.png", name: "Maria Trading" },
  { src: "/clients/rersud.png", name: "RER Sud" },
  { src: "/clients/romcim.png", name: "Romcim" },
  { src: "/clients/rominserv.png", name: "Rominserv" },
  { src: "/clients/romwaste.jpg", name: "Rom Waste" },
  { src: "/clients/socep.jpg", name: "Socep" },
  { src: "/clients/soceram.png", name: "Soceram" },
  { src: "/clients/sorocam.png", name: "Sorocam" },
  { src: "/clients/umex.png", name: "Umex" },
  { src: "/clients/xannat-minerals.jpg", name: "Xannat Minerals" },
];

const LogoCarousel = () => {
  const { t } = useLang();
  // Duplicate the list so the marquee wraps seamlessly.
  const items = [...LOGOS, ...LOGOS];

  return (
    <section
      data-testid="clients-logos"
      className="border-t border-white/10 bg-[#050505] overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-16 lg:pt-20 pb-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="block w-10 h-px bg-[#FF4500]" />
          <span className="text-overline text-[#FF4500]">
            {t.clients.logosTitle}
          </span>
        </div>
        <p className="text-white/60 text-sm max-w-2xl">{t.clients.logosNote}</p>
      </div>

      {/* Marquee track */}
      <div className="relative py-10 mask-fade">
        <div className="flex gap-6 marquee items-stretch">
          {items.map((logo, i) => (
            <div
              key={`${logo.name}-${i}`}
              data-testid={`client-logo-${i}`}
              className="shrink-0 h-24 flex items-center justify-center px-6 border border-white/10 bg-white hover:border-[#FF4500] transition-colors"
              title={logo.name}
            >
              <img
                src={logo.src}
                alt={logo.name}
                loading="lazy"
                className="max-h-16 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;
